import React, {FC, useEffect, useState} from 'react'
import axios from 'axios'
import { RoleTable } from './components/RoleTable'
import { Auth } from 'aws-amplify'

const API_URL_API = process.env.REACT_APP_API_URL_BACKEND
export const GET_ALL_ROLES_URL = `${API_URL_API}/role`


const RoleList: FC = () => {

  const [loading, SetLoading] = useState(true);
  const [roles, setRoles] = useState([]);


  useEffect(() => {
    getAllRoles()
  },[])


  const getAllRoles = async () => {
    
    try {

      const auth = await Auth.currentSession();
      const token = auth.getAccessToken().getJwtToken();

      const {data: result} = await axios.get(GET_ALL_ROLES_URL,{
        headers : {
          Authorization: `Bearer ${token}`
        }
      });
        setRoles(result.data);  
        SetLoading(false);
      console.log(roles);
    } catch (err) {
      console.log(err)
    }     
  };

    return (
        <>
        {
          loading ? (
            <div className='d-flex flex-center'>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
            </div>
          ) : (
            <RoleTable roles={roles} getAllRoles={getAllRoles} className='mb-5 mb-xl-8' /> 
          )
        }
        </>
  )
}

export {RoleList}
